import {
  CustomSectionAttributes,
  PageTemplateSectionSource,
} from 'api/custom-section/types';
import { HttpClient } from 'api/http-client';
import { MeetingTemplateSection } from 'api/pages';
import { getPageTemplateBuilderBasePath } from '../template-path';
import { PageType } from '../types';
import {
  GetSectionsAvailableForAddParams,
  GetUpdatedSectionsForNewSourcesParams,
  GetUpdatedSectionsForNewSourcesPayload,
  SearchSectionsParams,
} from './types';

class TemplateBuilderAPIClient extends HttpClient {
  public getSectionsForTemplates = (
    templateIds: number[],
    pageType?: PageType,
  ): Promise<CustomSectionAttributes[]> =>
    this.get<CustomSectionAttributes[]>(
      `${getPageTemplateBuilderBasePath(pageType)}/sections/group-source-sections`,
      {
        params: {
          pageTemplateIds: templateIds.join(','),
        },
      },
    );
  public getUpdatedSectionsForNewSources = (
    params: GetUpdatedSectionsForNewSourcesParams,
    pageType?: PageType,
  ): Promise<CustomSectionAttributes[]> =>
    this.post<
      GetUpdatedSectionsForNewSourcesPayload,
      unknown,
      CustomSectionAttributes[]
    >(
      `${getPageTemplateBuilderBasePath(pageType)}/sections/regroup-source-sections`,
      {
        sourceTemplateSectionsState: params.sections,
        targetPageTemplateIds: params.newSourceIds,
        sourcePageTemplateIds: params.oldSourceIds,
      },
    );
  public searchSections = (
    params: Partial<SearchSectionsParams>,
    pageType?: PageType,
  ): Promise<PageTemplateSectionSource[]> =>
    this.get<PageTemplateSectionSource[]>(
      `${getPageTemplateBuilderBasePath(pageType)}/sections/search`,
      {
        params: {
          ...params,
          pageTemplateIds: params.pageTemplateIds?.join(','),
        },
      },
    );
  public getSectionsAvailableForAdd = (
    params: GetSectionsAvailableForAddParams,
    pageType?: PageType,
  ): Promise<MeetingTemplateSection[]> =>
    this.post<
      GetSectionsAvailableForAddParams,
      unknown,
      MeetingTemplateSection[]
    >(
      `${getPageTemplateBuilderBasePath(pageType)}/sections/group-source-sections-from-state`,
      params,
    );
}

export const PageTemplateBuilderAPI = new TemplateBuilderAPIClient();
